// A function that when attached to an element's `onMouseDown` event, will fire the resulting
// callback when a user clicks (mouse down then a mouse up) within a certain set threshold
export default function singleClickDetector(callback, threshold = 250) {
  // If text is currently deselected, then don;t trigger a click because by clicking away the user
  // probably was expecting the text to deselect.
  const selection = window.getSelection() as any;
  if (
    typeof selection.extentOffset !== 'undefined' &&
    typeof selection.baseOffset !== 'undefined'
  ) {
    const textCurrentlySelected =
      selection.extentOffset !== selection.baseOffset;
    if (textCurrentlySelected) {
      return;
    }
  }

  const mouseDownTime = performance.now();
  const mouseup = () => {
    // A single mouse down should handle at most one mouse up. Without removing
    // this listener here, another click inside the cleanup window can invoke
    // the previous click's callback a second time.
    window.removeEventListener('mouseup', mouseup);

    const mouseUpTime = performance.now();

    // See if the user lifted the mouse within the threshold
    if (mouseUpTime - mouseDownTime < threshold) {
      callback();
    }
  };
  window.addEventListener('mouseup', mouseup);

  // By this point, we know it's definitely not a mouse click
  setTimeout(() => {
    window.removeEventListener('mouseup', mouseup);
  }, threshold * 2);
}
